import React from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch, SearchBox, Hits, connectStateResults, Pagination, Configure,
} from 'react-instantsearch-dom';
import SearchHit from '~2-components/Search/SearchHit/SearchHit';
import Icon from '~2-components/IconInline/IconInline';

const searchClient = algoliasearch( process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY);

const SearchResults = connectStateResults(({
    searchState, searchResults, error,
}) => {
    if (searchResults && searchResults.nbHits === 0) {
        return (
            <p>Please try a different search term.</p>
        );
    }

    // only show results if there's a search query
    if (searchState.query) {
        return (
            <div className="search-results">
                <Hits hitComponent={SearchHit} />
                <Pagination
                    showFirst={false}
                    showLast={false}
                    translations={{ previous: <Icon icon="chevron-left" />, next: <Icon icon="chevron-right" /> }}
                />
            </div>
        );
    }

    if (error) {
        return (
            <p>{error ? `${error.message}` : ''}</p>
        );
    }
    return (
        <div />
    );
});

const Search = () => (
    <div className="search">
        <div className="search-overlay" />
        <div className="search-content">
            {(process.env.GATSBY_ALGOLIA_INDEX_NAME) && (
                <InstantSearch
                    indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
                    searchClient={searchClient}
                >
                    <Configure
                        filters="workflowStep:true"
                        hitsPerPage={10}
                    />
                    <div className="search-content input-wrapper">
                        <SearchBox translations={{
                            submitTitle: 'Submit your search query.',
                            placeholder: 'Search',
                        }}
                        />
                    </div>
                    <SearchResults />
                </InstantSearch>
            )}
        </div>
    </div>
);

export default Search;
